<template>
  <main>
  </main>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import { BTabs, BTab, BRow, BCol, BCard } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import AppEchartBar from "@core/components/charts/echart/AppEchartBar.vue";
import AppEchartDoughnut from "@core/components/charts/echart/AppEchartDoughnut.vue";
import AppEchartLine from "@core/components/charts/echart/AppEchartLine.vue";
export default {
  data() {
    return {
      card: {},
    };
  },
  components: {
    StatisticCardHorizontal,
    BAlert,
    BTabs,
    BTab,
    BRow,
    BCol,
    BCard,
    AppEchartBar,
    AppEchartDoughnut,
    AppEchartLine,
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
  },
  methods: {
    postCardInfo() {
      let payload = {
        show: {
          penjualan: false,
          sales: false,
          karyawan: false,
          collection: false,
          assetTotal: true,
          assetNilai: true,
          barangMobilNilai: false,
          keuntungan: false,
        },
      };

      this.$store
        .dispatch("dashboard/cardInfo", payload)
        .then((res) => {
          this.card = res;
        })
        .catch((e) => console.error(e));
    },
  },
  mounted() {
    this.postCardInfo();
  },
};
</script>
